/**
 * @generated SignedSource<<0f7c5af4da00d3a2d97432e1136c8e6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluencePageSelectSearchPagesQuery$variables = {
  query: string;
  space: string;
};
export type ConfluencePageSelectSearchPagesQuery$data = {
  readonly viewer: {
    readonly confluenceSearch: ReadonlyArray<{
      readonly id: string;
      readonly space: string;
      readonly title: string;
    }>;
  };
};
export type ConfluencePageSelectSearchPagesQuery = {
  response: ConfluencePageSelectSearchPagesQuery$data;
  variables: ConfluencePageSelectSearchPagesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "space"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "space",
      "variableName": "space"
    },
    {
      "kind": "Variable",
      "name": "text",
      "variableName": "query"
    }
  ],
  "concreteType": "ConfluencePageNode",
  "kind": "LinkedField",
  "name": "confluenceSearch",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "space",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfluencePageSelectSearchPagesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConfluencePageSelectSearchPagesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "50ca045561e747eb18a55be0ea2b132d",
    "id": null,
    "metadata": {},
    "name": "ConfluencePageSelectSearchPagesQuery",
    "operationKind": "query",
    "text": "query ConfluencePageSelectSearchPagesQuery(\n  $query: String!\n  $space: String!\n) {\n  viewer {\n    confluenceSearch(text: $query, space: $space) {\n      id\n      title\n      space\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "be21a15d3e63ee7c36bc413c63b7d330";

export default node;
